import { MAX_IMAGES, MAX_IMAGE_BYTES, validateImages } from './chatImages.mjs';
import { documentMime, exactKeys } from './chatDocumentContext.mjs';
export { documentMime } from './chatDocumentContext.mjs';
export const DOCUMENT_ERRORS = Object.freeze({
  chat_document_invalid: 'Choose a valid PDF, DOCX, TXT, MD, CSV, XLSX or PPTX file. Legacy and macro-enabled Office files are not supported.',
  chat_attachments_too_many: 'Attach at most 4 images or documents per message.',
  chat_attachments_too_large: 'Images and documents must total 5 MiB or less per message.',
  chat_document_unreadable: 'No readable text could be extracted. Try a text-based file, or paste the relevant text.',
  chat_document_text_too_large: 'Documents contain too much text. Attach a smaller selection (60,000 characters total).',
  chat_document_conversion_failed: 'Document text could not be extracted. Your message was not sent. Try again or paste the relevant text.',
});
export class ChatDocumentError extends Error {
  constructor(code = 'chat_document_invalid', status = 400) { super(DOCUMENT_ERRORS[code] || DOCUMENT_ERRORS.chat_document_invalid); this.code = code; this.status = status; }
}
export function validateDocuments(value) {
  if (value === undefined) return [];
  if (!Array.isArray(value)) throw new ChatDocumentError();
  if (value.length > MAX_IMAGES) throw new ChatDocumentError('chat_attachments_too_many');
  let total = 0;
  return value.map((doc) => {
    if (!exactKeys(doc, ['name', 'mimeType', 'base64']) || !documentMime(doc.name) || documentMime(doc.name) !== doc.mimeType
      || typeof doc.base64 !== 'string') throw new ChatDocumentError();
    const encoded = doc.base64;
    if (encoded.length > Math.ceil(MAX_IMAGE_BYTES / 3) * 4) throw new ChatDocumentError('chat_attachments_too_large', 413);
    if (!encoded.length || encoded.length % 4 || !/^[A-Za-z0-9+/]*={0,2}$/.test(encoded)) throw new ChatDocumentError();
    const size = encoded.length / 4 * 3 - (encoded.endsWith('==') ? 2 : encoded.endsWith('=') ? 1 : 0);
    total += size;
    if (total > MAX_IMAGE_BYTES) throw new ChatDocumentError('chat_attachments_too_large', 413);
    try { if (btoa(atob(encoded)) !== encoded) throw new Error(); } catch { throw new ChatDocumentError(); }
    return { name: doc.name, mimeType: doc.mimeType, base64: encoded };
  });
}
export function validateChatAttachments(imageInput, documentInput) {
  const images = validateImages(imageInput), documents = validateDocuments(documentInput);
  if (images.length + documents.length > MAX_IMAGES) throw new ChatDocumentError('chat_attachments_too_many');
  const sizeOf = (encoded) => encoded.length / 4 * 3 - (encoded.endsWith('==') ? 2 : encoded.endsWith('=') ? 1 : 0);
  const bytes = images.reduce((n, image) => n + sizeOf(image.dataUrl.split(',')[1]), 0)
    + documents.reduce((n, doc) => n + sizeOf(doc.base64), 0);
  if (bytes > MAX_IMAGE_BYTES) throw new ChatDocumentError('chat_attachments_too_large', 413);
  return { images, documents };
}
